import { useEffect, useRef } from 'react';

const lerp = (a, b, t) => a + (b - a) * t;

// O ponto acompanha na hora e o anel chega depois (o atraso dá a sensação de peso).
function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return undefined;

    const dot = dotRef.current;
    const ring = ringRef.current;
    const target = { x: 0, y: 0 };
    const current = { x: 0, y: 0 };
    let visible = false;
    let frame;

    const onMove = (ev) => {
      target.x = ev.clientX;
      target.y = ev.clientY;
      if (!visible) {
        visible = true;
        current.x = target.x;
        current.y = target.y;
        dot.style.opacity = ring.style.opacity = 1;
      }
      const interactive = ev.target.closest && ev.target.closest('a, button, input, textarea, select, label');
      ring.classList.toggle('cursor-ring-active', !!interactive);
    };
    const onLeave = () => {
      visible = false;
      dot.style.opacity = ring.style.opacity = 0;
    };

    const tick = () => {
      dot.style.transform = `translate(${target.x - 5}px, ${target.y - 5}px)`;
      current.x = lerp(current.x, target.x, 0.14);
      current.y = lerp(current.y, target.y, 0.14);
      ring.style.transform = `translate(${current.x - 19}px, ${current.y - 19}px)`;
      frame = requestAnimationFrame(tick);
    };

    document.documentElement.classList.add('has-custom-cursor');
    window.addEventListener('mousemove', onMove);
    document.documentElement.addEventListener('mouseleave', onLeave);
    frame = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('mousemove', onMove);
      document.documentElement.removeEventListener('mouseleave', onLeave);
      document.documentElement.classList.remove('has-custom-cursor');
    };
  }, []);

  return (
    <>
      <span ref={dotRef} className="cursor-dot" />
      <span ref={ringRef} className="cursor-ring" />
    </>
  );
}

export default CustomCursor;
